module.exports = __webpack_public_path__ + "static/img/yinliangjia2.8a1716b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/yinliangjia2.png
// module id = 5QEj
// module chunks = 24